import {
	addressCityAtom,
	addressCountryAtom,
	addressPostalCodeAtom,
	addressStateAtom,
	addressStreetAtom,
} from 'features/generator/contentFormSections/LocationForm/addressAtoms'
import { useAtomValue } from 'jotai'

export const useFullLocation = () => {
	const street = useAtomValue(addressStreetAtom)
	const postalCode = useAtomValue(addressPostalCodeAtom)
	const city = useAtomValue(addressCityAtom)
	const state = useAtomValue(addressStateAtom)
	const country = useAtomValue(addressCountryAtom)

	return [street, postalCode, city, state, country]
		.filter((value) => value?.length)
		.join(', ')
}
